import React, { useEffect } from "react";
import { connect } from "react-redux";
import PolicysComponent from "./PolicysComponent";
import { BrandsManagementsFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function PolicysContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    if (props.user.uid) {
      props.BrandsManagementsFunction("get", EndPoints["Policys"]);
      props.BrandsManagementsFunction(
        "get",
        EndPoints["Incoterms"],
        null,
        EndPoints["Incoterms"],
        null,
        {
          is_active: "True",
        }
      );
      props.BrandsManagementsFunction(
        "get",
        EndPoints["ShippingTerms"],
        null,
        EndPoints["ShippingTerms"],
        null,
        {
          is_active: "True",
        }
      );
    }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <PolicysComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  [EndPoints["Policys"]]: state.modules[EndPoints["Policys"]],
  [EndPoints["Incoterms"]]: state.modules[EndPoints["Incoterms"]],
  [EndPoints["ShippingTerms"]]: state.modules[EndPoints["ShippingTerms"]],

  loading: state.modules.loading,
});
const mapDispatchToProps = {
  BrandsManagementsFunction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PolicysContainer);
